export const MIME_TYPE_MAP: Record<string, string> = {
    // Image formats
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    bmp: 'image/bmp',
    webp: 'image/webp',
    svg: 'image/svg+xml',
    ico: 'image/x-icon',
    tiff: 'image/tiff',
    tif: 'image/tiff',
    heic: 'image/heic',
    heif: 'image/heif',
    avif: 'image/avif',
    jxl: 'image/jxl',

    // Video formats
    mp4: 'video/mp4',
    mov: 'video/quicktime',
    avi: 'video/x-msvideo',
    wmv: 'video/x-ms-wmv',
    flv: 'video/x-flv',
    webm: 'video/webm',
    m4v: 'video/x-m4v',
    '3gp': 'video/3gpp',
    mkv: 'video/x-matroska',
    ogv: 'video/ogg',
    ts: 'video/mp2t',
    mts: 'video/mp2t',
    m2ts: 'video/mp2t',
    f4v: 'video/x-f4v',
    asf: 'video/x-ms-asf',
    rm: 'application/vnd.rn-realmedia',
    rmvb: 'application/vnd.rn-realmedia-vbr',
    vob: 'video/mpeg',
    ogx: 'application/ogg',

    // Audio formats
    mp3: 'audio/mpeg',
    wav: 'audio/wav',
    aac: 'audio/aac',
    ogg: 'audio/ogg',
    flac: 'audio/flac',
    m4a: 'audio/mp4',
    wma: 'audio/x-ms-wma',
    opus: 'audio/opus',

    // Document formats
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    txt: 'text/plain',
    json: 'application/json',
};

export enum MediaFileType {
    VIDEO = 'video',
    IMAGE = 'image',
    DOCUMENT = 'document',
    AUDIO = 'audio',
    PHOTO = 'photo'
}

// This function maps the MIME-type (e.g.: "image/png", "video/mp4")
// to a MediaFileType enum.
const mapMimeTypeToMediaFileType = (mimeType: string | undefined): MediaFileType => {
    if (mimeType === undefined) {
        // Shouldn't happen, but just in case
        throw new Error('mimeType is required');
    }

    if (mimeType.startsWith('image/')) {
        return MediaFileType.IMAGE;
    }

    if (mimeType.startsWith('video/')) {
        return MediaFileType.VIDEO;
    }

    if (mimeType.startsWith('audio/')) {
        return MediaFileType.AUDIO;
    }

    if (mimeType === 'application/pdf') {
        return MediaFileType.DOCUMENT;
    }

    throw new Error(`Unsupported media type: ${mimeType}`);
};

const getFileExtension = (uri: string): string => {
    if (uri === undefined || uri === null) return '';

    const lastSegment = uri.split('/').pop() ?? ''; // get filename
    const parts = lastSegment.split('.');

    return parts.length > 1 ? parts.pop()?.toLowerCase() ?? '' : '';
};

const getMimeTypeFromPath = (uri: string): string | undefined => {
    if (uri === undefined) {
        return undefined;
    }

    const extension = getFileExtension(uri);
    return MIME_TYPE_MAP[extension.toLowerCase()];
};

const getFileTypeFromPath = (uri: string): string | undefined => getMimeTypeFromPath(uri);

export {
    getFileExtension,
    getFileTypeFromPath,
    mapMimeTypeToMediaFileType,
};
